module.exports = __webpack_public_path__ + "static/media/anxiety.86b65e18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/anxiety.jpg
// module id = 627
// module chunks = 11